import { Injectable } from '@angular/core';
import {
    GuidebookServerFactor,
    RelationshipGuideServer
} from '../core-data-model/Guidebook.interface';
import {
    FactorInfo,
    RelationshipGuide
} from '../core-data-model/PatternInsights.interface';

@Injectable({
    providedIn: 'root'
})
export class GuidebookTransformers {
    transformFactorInfo(server: GuidebookServerFactor): FactorInfo {
        return {
            behaviorTraits: server.behaviorTraits,
            descriptor: server.descriptor,
            letter: server.letter,
            motivatingNeedTraits: server.motivatingNeedTraits,
            name: server.name,
            primaryTrait: server.primaryTrait,
            sigmaRangeTraits: server.sigmaRangeTraits,
            sigmaZone: server.sigmaZone,
            absoluteSigmaValue: server.absoluteSigmaValue
        };
    }

    transformRelationshipGuide(
        server: RelationshipGuideServer
    ): RelationshipGuide {
        return {
            type: server.relationshipType,
            strength: server.relationshipStrengths,
            caution: server.relationshipCautions,
            tip: server.relationshipTips
        };
    }
}
